import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import UserService from 'services/UserService';
import { fetchProducts } from 'store/slices/productSlice';

/**
 * Component xử lý redirect sau khi đăng nhập.
 * Nếu username là 'ahamove_admin', không redirect đến dashboard
 * mà redirect đến trang sản phẩm đầu tiên.
 */
const AuthenticatedRedirect = () => {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.product.products);
  const productLoading = useSelector((state) => state.product.loading);
  const [username, setUsername] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);

  useEffect(() => {
    // Lấy thông tin profile và products song song
    UserService.getProfile()
      .then((res) => {
        const data = res?.data;
        if (data?.username) {
          setUsername(data.username);
        }
        setProfileLoading(false);
      })
      .catch(() => {
        setProfileLoading(false);
      });

    dispatch(fetchProducts());
  }, [dispatch]);

  // Đang loading profile
  if (profileLoading) {
    return null;
  }

  // Nếu không phải ahamove_admin, redirect thẳng vào dashboard
  if (username !== 'ahamove_admin') {
    return <Navigate replace to={AUTHENTICATED_ENTRY} />;
  }

  // Nếu là ahamove_admin, đợi products load xong
  if (productLoading) {
    return null;
  }

  // Redirect đến sản phẩm đầu tiên
  if (products.length > 0) {
    const firstProduct = products[0];
    if (firstProduct.items && firstProduct.items.length > 0) {
      const firstItem = firstProduct.items[0];
      const redirectPath = firstItem?.code === 'image_inspection'
        ? '/image-inspection'
        : `/vehicle/orders?productCode=${firstProduct.productCode}&pbpCode=${firstItem.pbpCode}&category=${firstProduct.productCategory}&isDueForRenewal=${firstProduct?.isDueForRenewal}&isOrderCreatable=${firstProduct?.isOrderCreatable}`;
      return <Navigate replace to={redirectPath} />;
    }
  }

  // Fallback: nếu không có products, vẫn vào dashboard
  return <Navigate replace to={AUTHENTICATED_ENTRY} />;
};

export default AuthenticatedRedirect;
